import { Box, styled, type SxProps, type Theme } from '@mui/material';

export const workboardTaskFieldOverrides = (theme: Theme): Record<string, unknown> => ({
  '& .MuiOutlinedInput-root': {
    backgroundColor: theme.palette.background.paper,
  },
  '& .MuiSelect-select:focus': {
    backgroundColor: `${theme.palette.background.paper} !important`,
  },
  '& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus, & input:-webkit-autofill:active':
    {
      WebkitBoxShadow: `0 0 0 1000px ${theme.palette.background.paper} inset !important`,
      backgroundColor: `${theme.palette.background.paper} !important`,
    },
});

export const workboardTaskModalBoxSx: SxProps<Theme> = theme => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: '95vw',
  maxHeight: '95vh',
  overflow: 'auto',
  backgroundColor: theme.palette.mode === 'dark' ? theme.palette.background.default : '#f0f2f5',
  borderRadius: theme.spacing(2),
  padding: theme.spacing(1),
  paddingTop: theme.spacing(4),
  boxShadow: theme.shadows[24],
  outline: 'none',
  '&:focus, &:focus-visible, &:focus-within': {
    outline: 'none',
  },
  ...workboardTaskFieldOverrides(theme),
});

export const WorkboardTaskBentoGrid = styled(Box, {
  shouldForwardProp: prop => prop !== 'showNotesColumn',
})<{ showNotesColumn?: boolean }>(({ theme, showNotesColumn }) => ({
  display: 'grid',
  gridTemplateColumns: showNotesColumn ? '1fr 1fr 1fr 1fr' : '1fr 1fr 1fr',
  gap: '12px',
  minHeight: 480,
  [theme.breakpoints.down('lg')]: {
    gridTemplateColumns: '1fr 1fr',
  },
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: '1fr',
  },
}));

export const CloseButtonContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(1),
  right: theme.spacing(1),
  zIndex: 1,
}));

export const ModalFooter = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: theme.spacing(1),
  padding: theme.spacing(1.5, 1, 0.5),
  marginTop: theme.spacing(1),
}));

export const TaskNameField = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  width: '100%',
}));

export const FieldLabel = styled('span')(({ theme }) => ({
  fontSize: '0.8rem',
  color: theme.palette.text.secondary,
}));

export const FolderLocation = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(0.5),
  fontSize: '0.8rem',
  color: theme.palette.text.secondary,
  fontStyle: 'italic',
  wordBreak: 'break-word',
}));

export const StatusHeaderRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  gap: '0.5rem',
  flexWrap: 'wrap',
});
